import {imgServerIp, serverIpAddress, userImgAddress} from './systemConfig'

// 该文件内为全局过滤器 filters 
String.prototype.replaceAll = function(oldStr, newStr){
  let str = this
  let strList = str.split(oldStr)
  let resStr = ''
  for(var i = 0; i < strList.length; i++){
    if(i < strList.length - 1){
      resStr += strList[i] + newStr
    }else{
      resStr += strList[i]
    }
  }
  return resStr
}

// 自动补全地址
export const $addurlScience = (url) => {
  if(url){
    return url.replace('/profile', imgServerIp + '/profile')
  }else{
    return ''
  }
}

// 自动补全地址
export const $addurlScienceAll = (url) => {
  if(url){
    return url.replaceAll('/profile', imgServerIp + '/profile')
  }else{
    return ''
  }
}

// 补全用户头像路径和商品评论图片路径
export const $addUserHandImg = (url) => {
  if(url){
    return userImgAddress + url
  }
}




// WEBPACK FOOTER //
// ./src/util/filters.js